export default {
  JOIN_NOW:   '@@join/JOIN_NOW',
  START_PAGE: '@@join/START_PAGE'
};